var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.125 23.854C4.2954 22.928 0.00309483 17.9027 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C23.997 17.9024 19.7052 22.9275 13.876 23.854V15.469H16.671L17.203 12H13.876V9.748C13.8288 9.2234 14.0228 8.70581 14.4031 8.34143C14.7835 7.97704 15.3089 7.80541 15.831 7.875H17.345V4.921C16.4562 4.77762 15.5582 4.69941 14.658 4.687C11.917 4.687 10.125 6.348 10.125 9.356V12.001H7.079V15.47H10.125V23.854Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.dff3e8077f59a92f36053d6a95a69510.svg";
export { ForwardRef as ReactComponent };